'use client'

import { useGlobalContext } from '@/context/context'
import React, { useTransition, useEffect, useState, useRef } from 'react'
import styled, { css } from 'styled-components'
import { useRouter } from '../navigation.js'
import { usePathname } from 'next/navigation'
import { isCasinoRoute } from '@/utils/casinoTheme.mjs';
import {useLocale, useTranslations} from 'next-intl';
import gsap from 'gsap'
import { calendarPalette as palette, isCasinoTheme } from '@/components/calendar-stuff/CalendarPalette';

const Container = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    background-color: red;
    color: white;
    height: 2rem;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    display: flex;
    padding: 0 .5rem;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10000; //10
    /* width: 3rem; */
    opacity: 0;
    font-size: .8rem;
    &:focus-visible { outline: 3px solid #e6bd78; outline-offset: 3px; }
    &:disabled { cursor: not-allowed; }
    ${props => props.$calendar && css`
        z-index: 280;
        background: ${isCasinoTheme ? palette.heading : palette.surface};
        color: ${isCasinoTheme ? palette.onDark : palette.heading};
        border: 1px solid ${palette.border};
        border-top: 0;
        padding: 0 .75rem;
        font-weight: 600;
        &:hover:not(:disabled) { background: ${isCasinoTheme ? palette.heroMid : palette.accentTint}; }
        &:focus-visible { outline-color: ${palette.accent}; }
    `}
    /* display: none; */
`

function LanguageToggle() {
  const { languageToggle, setLanguageToggle, paymentInProgress } = useGlobalContext();
  const router = useRouter();
  const pathname = usePathname();
  const isCalendar = isCasinoTheme && isCasinoRoute(pathname);
  const [isPending, startTransition] = useTransition();
  const locale = useLocale();
  const [visible, setVisible] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    setVisible(true);
  }, [])

  useEffect(() => {
    if (visible) {
      gsap.to(containerRef.current, { opacity: isCalendar ? 1 : .6, duration: .1 });
    }
  }, [visible, isCalendar])

  const handleToggleLanguage = () => {
    if (paymentInProgress) return;
    if (locale == 'en') {
        setLanguageToggle('fr');
        // router.replace('en', 'fr');
        const currentPathname = window.location.pathname;
        const newPathname = currentPathname.replace('/en', '/fr');
        window.location.href = newPathname;
        return;
      }
      else if (locale == 'fr') {
        // router.replace('http://localhost:3000/en');
        setLanguageToggle('en');
        const currentPathname = window.location.pathname;
        const newPathname = currentPathname.replace('/fr', '/en');
        window.location.href = newPathname;
        return;
    }
  }

  if (!visible) {
    return;
  }

  return (
    <Container
      as={isCalendar ? 'button' : 'div'}
      $calendar={isCalendar}
      type={isCalendar ? 'button' : undefined}
      disabled={isCalendar ? paymentInProgress : undefined}
      ref={containerRef}
      onClick={(e) => handleToggleLanguage()}
    >
        {locale === 'en' && (
            <span>Français</span>
        )} 
        {locale === 'fr' && (
            <span>English</span>
        )} 
    </Container>
  )
}

export default LanguageToggle

// import {useLocale, useTranslations} from 'next-intl';
// import {locales} from '../config';
// import LocaleSwitcherSelect from './LocaleSwitcherSelect';

// export default function LocaleSwitcher() {
//   const t = useTranslations('LocaleSwitcher');
//   const locale = useLocale();

//   return (
//     <LocaleSwitcherSelect defaultValue={locale} label={t('label')}>
//       {locales.map((cur) => (
//         <option key={cur} value={cur}>
//           {t('locale', {locale: cur})}
//         </option>
//       ))}
//     </LocaleSwitcherSelect>
//   );
// }
